// Einsatzgebiete (Schwerpunktregionen / Hubs) – individuelle, hilfreiche Inhalte.
export const regions = [
  {
    slug: "ulm-neu-ulm",
    name: "Ulm, Neu-Ulm und Umgebung",
    short: "Ulm & Neu-Ulm",
    metaTitle: "Entrümpelung Ulm, Neu-Ulm, Dornstadt & Blaustein | Rümpeltaxi",
    metaDescription:
      "Entrümpelung und Haushaltsauflösung in Ulm, Neu-Ulm, Dornstadt, Blaustein, Blaubeuren, Beimerstetten, Erbach und Langenau. Rümpeltaxi aus Altenstadt – Tel. 0151 70004440.",
    h1: "Entrümpelung in Ulm, Neu-Ulm und Umgebung",
    orientation: "Orientierung: rund 30 km rund um Ulm und Neu-Ulm",
    intro:
      "Ulm und Neu-Ulm bilden zusammen mit den umliegenden Gemeinden unseren wichtigsten Einsatzraum. Von der Altbauwohnung in der Ulmer Innenstadt bis zum Einfamilienhaus in Dornstadt oder Blaustein räumen wir Wohnungen, Häuser, Keller und Garagen – mit kurzer Anfahrt von unserem Sitz in Altenstadt an der Iller.",
    body: [
      "Die Doppelstadt Ulm und Neu-Ulm ist dicht bebaut: Mehrfamilienhäuser mit engen Treppenhäusern, Wohnungen ohne Aufzug, Tiefgaragen und Innenstadtlagen, in denen der Transporter nur mit Halteverbotszone stehen kann. Solche Punkte klären wir vor jedem Einsatz, damit die Räumung am Tag selbst ohne Verzögerung läuft. Auch mit Hausverwaltungen und Maklern in Ulm arbeiten wir regelmäßig zusammen, wenn eine Wohnung termingerecht übergeben werden muss.",
      "Nördlich und westlich der Stadt ändert sich das Bild. In Dornstadt, Beimerstetten und Langenau stehen viele Einfamilien- und Reihenhäuser aus den siebziger bis neunziger Jahren mit großen Kellern, Garagen und Gartenhäusern. In Blaustein und Blaubeuren am Rand der Schwäbischen Alb kommen ältere Anwesen mit Nebengebäuden hinzu, gelegentlich mit schwieriger Zufahrt. Hier lohnt sich eine kurze Besichtigung, die wir bei größeren Objekten kostenlos anbieten.",
      "Südlich von Ulm entlang der Iller – in Erbach, Illerkirchberg und Dietenheim – sind wir besonders häufig unterwegs, weil diese Orte praktisch auf dem Weg zwischen Altenstadt und Ulm liegen. Kleine Aufträge wie ein einzelnes Kellerabteil oder eine Garage lassen sich dort gut mit anderen Terminen verbinden, was sich für Sie im Preis bemerkbar macht.",
      "Der Ablauf ist überall gleich: Sie schicken uns über das Anfrageformular oder per WhatsApp ein paar Fotos und nennen Ort, Etage und Zugang. Sie erhalten ein Angebot mit klar getrennten Positionen für Arbeitszeit, Transport und Entsorgung. Beim Räumen sortieren wir direkt beim Verladen; Brauchbares geben wir nach Absprache weiter, der Rest geht zu den Entsorgungsanlagen in Ulm, im Alb-Donau-Kreis und im Landkreis Neu-Ulm. Auf Wunsch übergeben wir besenrein.",
    ],
    towns: ["Ulm", "Neu-Ulm", "Dornstadt", "Blaustein", "Blaubeuren", "Beimerstetten", "Erbach", "Illerkirchberg", "Langenau", "Dietenheim"],
    audiences: ["Privathaushalte", "Erben & Angehörige", "Hausverwaltungen", "Immobilienmakler"],
    objectTypes: ["Wohnungen", "Ein- und Mehrfamilienhäuser", "Keller & Dachböden", "Gewerbeflächen"],
    highlights: [
      "Räumungen in Alt- und Neubauten",
      "Enge Zufahrten und Halteverbotszonen im Blick",
      "Zusammenarbeit mit Hausverwaltungen und Maklern",
    ],
    faq: [
      {
        q: "Entrümpelung in Beimerstetten – kommen Sie auch dorthin?",
        a: "Ja. Rümpeltaxi sitzt in Altenstadt an der Iller, Beimerstetten erreichen wir über die A7 in kurzer Fahrzeit. Schicken Sie uns ein paar Fotos, und Sie erhalten ein Angebot, ohne dass wir vorher anfahren müssen.",
      },
      {
        q: "Räumen Sie in Blaubeuren auch Häuser mit Nebengebäuden?",
        a: "Ja. Ältere Anwesen mit Scheune, Schuppen oder Garage sind für uns Alltag. Bei größeren Objekten in Blaubeuren kommen wir zur kostenlosen Besichtigung vorbei.",
      },
      {
        q: "Wie schnell geht eine Kellerräumung in Langenau oder Dornstadt?",
        a: "Ein einzelnes Kellerabteil oder eine Garage erledigen wir meist in wenigen Stunden. Den Termin legen wir gerne mit anderen Einsätzen in der Umgebung zusammen.",
      },
    ],
  },
  {
    slug: "senden-voehringen",
    name: "Senden, Vöhringen und Umgebung",
    short: "Senden & Vöhringen",
    metaTitle: "Entrümpelung Senden & Vöhringen | Rümpeltaxi Altenstadt",
    metaDescription:
      "Entrümpelung und Haushaltsauflösung in Senden, Vöhringen, Nersingen und Elchingen. Rümpeltaxi aus Altenstadt (Iller) – kurze Anfahrt. Tel. 0151 70004440.",
    h1: "Entrümpelung in Senden, Vöhringen und Umgebung",
    orientation: "Orientierung: der Illerraum zwischen Altenstadt und Neu-Ulm sowie das Donautal bei Elchingen",
    intro:
      "Senden und Vöhringen liegen an der Iller genau zwischen unserem Sitz in Altenstadt und Neu-Ulm. Zusammen mit Nersingen und Elchingen bilden sie den Einsatzraum, den wir am schnellsten erreichen – ideal, wenn eine Wohnung kurzfristig geräumt oder ein Keller vor einer Übergabe leer sein muss.",
    body: [
      "Vöhringen mit den Ortsteilen Illerberg, Thal und Illerzell ist nur wenige Minuten von Altenstadt entfernt. Die Bebauung ist gemischt: Wohnblocks aus der Nachkriegszeit rund um das Zentrum, dazu viele Einfamilienhäuser mit Garage und Keller. Typische Aufträge sind Wohnungsauflösungen nach einem Umzug ins Pflegeheim, die Räumung eines Elternhauses vor dem Verkauf und Kellerentrümpelungen in Mehrfamilienhäusern.",
      "Senden ist die größte Stadt im südlichen Landkreis Neu-Ulm. Neben der Kernstadt mit ihren Wohnanlagen gehören Ay, Aufheim, Witzighausen, Wullenstetten, Hittistetten und Freudenegg dazu. In den Wohnanlagen der Sendener Innenstadt achten wir auf Aufzuggrößen, Stellplätze und die Abstimmung mit der Hausverwaltung; in den Ortsteilen räumen wir häufiger Häuser mit Nebengebäuden, Werkstätten und Gartenhäusern.",
      "Nersingen mit Straß, Leibi, Oberfahlheim und Unterfahlheim sowie Elchingen mit Ober-, Unter- und Thalfingen liegen nördlich an der Donau und sind über die A7 und die B10 schnell erreichbar. Hier werden wir oft von Angehörigen beauftragt, die selbst weiter entfernt wohnen: Wir übernehmen den Schlüssel, räumen, dokumentieren mit Fotos und übergeben die Wohnung auf Wunsch direkt an Vermieter oder Käufer.",
      "Weil die Wege kurz sind, können wir in diesem Raum auch kleine Aufträge wirtschaftlich anbieten – ein Kellerabteil, eine Garage, ein paar Möbelstücke. Sie schicken uns Fotos, nennen Etage und Zugang und erhalten ein Angebot mit festem Preis für den vereinbarten Umfang. Beim Verladen trennen wir Holz, Metall, Elektro und Restmüll und bringen alles zu den Wertstoffhöfen und Entsorgern im Landkreis Neu-Ulm. Gut Erhaltenes geben wir nach Absprache weiter.",
    ],
    towns: ["Senden", "Vöhringen", "Nersingen", "Elchingen", "Ay", "Wullenstetten", "Illerberg", "Straß", "Thalfingen"],
    audiences: ["Privathaushalte", "Angehörige außerhalb der Region", "Hausverwaltungen", "Vermieter"],
    objectTypes: ["Wohnungen in Wohnanlagen", "Einfamilienhäuser", "Keller & Garagen", "Nebengebäude"],
    highlights: [
      "Kürzeste Anfahrt aller Einsatzgebiete – schnelle Termine",
      "Kleine Aufträge wirtschaftlich möglich",
      "Schlüsselübergabe mit Fotodokumentation",
    ],
    faq: [
      {
        q: "Wie schnell können Sie in Vöhringen einen Termin anbieten?",
        a: "Vöhringen liegt direkt neben Altenstadt. In der Regel finden wir innerhalb weniger Tage einen Termin, bei dringenden Übergaben oft noch schneller.",
      },
      {
        q: "Räumen Sie in Senden auch Wohnungen in größeren Wohnanlagen?",
        a: "Ja. Wir stimmen uns mit der Hausverwaltung ab, prüfen Aufzug und Stellplatz vorab und hinterlassen Treppenhaus und Wohnung sauber.",
      },
      {
        q: "Ich wohne nicht in Elchingen – geht die Räumung auch ohne mich?",
        a: "Ja. Sie übergeben uns den Schlüssel, wir halten Sie telefonisch auf dem Laufenden, schicken Fotos vom Ergebnis und geben die Wohnung auf Wunsch direkt an den Vermieter weiter.",
      },
    ],
  },
  {
    slug: "illertissen-allgaeu",
    name: "Illertissen und das Allgäu",
    short: "Illertissen & Allgäu",
    metaTitle: "Entrümpelung Illertissen, Weißenhorn & Altenstadt | Rümpeltaxi",
    metaDescription:
      "Entrümpelung und Haushaltsauflösung in Altenstadt, Illertissen, Weißenhorn, Pfaffenhofen a. d. Roth, Bellenberg, Buch und Holzheim. Rümpeltaxi vor Ort. Tel. 0151 70004440.",
    h1: "Entrümpelung in Illertissen und im Allgäu",
    orientation: "Orientierung: der südliche Landkreis Neu-Ulm rund um Altenstadt und Illertissen bis ins nördliche Allgäu",
    intro:
      "Hier sind wir zu Hause: Rümpeltaxi sitzt in Altenstadt an der Iller, direkt neben Illertissen. Weißenhorn, Pfaffenhofen an der Roth, Bellenberg, Buch und Holzheim liegen alle in wenigen Minuten Fahrzeit. Entsprechend flexibel können wir Entrümpelungen und Haushaltsauflösungen in diesem Raum planen.",
    body: [
      "Der südliche Landkreis Neu-Ulm ist ländlich geprägt. In Altenstadt, Illertissen, Bellenberg und Buch stehen viele Häuser seit Generationen in Familienbesitz – mit Scheunen, Werkstätten, Nebengebäuden und Kellern, in denen sich über Jahrzehnte einiges angesammelt hat. Alte Landmaschinen, Baumaterial, Werkzeug und Möbel aus mehreren Generationen sind keine Seltenheit. Wir haben die Fahrzeuge und die Erfahrung, solche Objekte strukturiert zu räumen.",
      "Weißenhorn und Pfaffenhofen an der Roth bringen dagegen städtischere Aufgaben mit: Wohnungen in der Weißenhorner Altstadt, Mehrfamilienhäuser in den Neubaugebieten, Gewerbeflächen im Industriegebiet. Hier klären wir vorab Zufahrt, Stellplatz und Aufzug und stimmen uns bei Bedarf mit der Hausverwaltung ab. Holzheim und die Ortsteile von Illertissen – Au, Jedesheim, Tiefenbach und Betlinshausen – erreichen wir ebenfalls in kürzester Zeit.",
      "Der Vorteil der kurzen Wege: Eine Besichtigung ist unkompliziert, und wir können Termine auch kurzfristig anbieten. Bei kleineren Objekten genügen ein paar Fotos über das Anfrageformular oder per WhatsApp. Sie erhalten ein Angebot, in dem Arbeitszeit, Transport und Entsorgung getrennt ausgewiesen sind. Der Preis gilt für den vereinbarten Umfang – kommen Wünsche hinzu, besprechen wir sie offen.",
      "Beim Räumen sortieren wir konsequent: Holz, Metall, Elektrogeräte, Sperrmüll und Wertstoffe gehen getrennt zu den Entsorgungsstellen im Landkreis Neu-Ulm. Altöl, Farben, Reifen oder Chemikalien aus Werkstätten und Scheunen entsorgen wir gesondert und regelkonform. Persönliche Unterlagen und Erinnerungsstücke legen wir beiseite. Wer möchte, erhält die Räume besenrein zurück – bereit für Verkauf, Vermietung oder die eigene Nutzung.",
    ],
    towns: ["Altenstadt", "Illertissen", "Weißenhorn", "Pfaffenhofen an der Roth", "Bellenberg", "Buch", "Holzheim", "Kellmünz", "Babenhausen"],
    audiences: ["Privathaushalte", "Landwirtschaftliche Anwesen", "Betreuer", "Gewerbe"],
    objectTypes: ["Wohnhäuser", "Scheunen & Nebengebäude", "Keller & Dachböden", "Außenbereiche"],
    highlights: [
      "Betrieb vor Ort in Altenstadt – keine Anfahrtskosten im Umkreis",
      "Scheunen-, Werkstatt- und Außenbereichsräumungen",
      "Kurzfristige Besichtigung und Termine",
    ],
    faq: [
      {
        q: "Räumen Sie in Weißenhorn auch Wohnungen in der Altstadt?",
        a: "Ja. Enge Gassen und begrenzte Stellplätze kennen wir aus Weißenhorn gut. Wir klären vorab, wo der Transporter stehen kann, und planen entsprechend.",
      },
      {
        q: "Entrümpeln Sie in Buch oder Bellenberg auch Scheunen mit altem Gerät?",
        a: "Ja. Landwirtschaftliches Gerät, Baumaterial und Werkstattinventar räumen wir regelmäßig. Besonderheiten wie Altöl oder Reifen besprechen wir vorab, damit die Entsorgung korrekt läuft.",
      },
      {
        q: "Fallen für Pfaffenhofen an der Roth Anfahrtskosten an?",
        a: "Nein. Pfaffenhofen liegt im direkten Umkreis unseres Sitzes in Altenstadt – Anfahrtskosten berechnen wir hier nicht.",
      },
    ],
  },
  {
    slug: "memmingen",
    name: "Memmingen und Umgebung",
    short: "Memmingen",
    metaTitle: "Entrümpelung Memmingen | Rümpeltaxi Altenstadt",
    metaDescription:
      "Entrümpelung und Haushaltsauflösung in Memmingen, Kellmünz und Babenhausen. Rümpeltaxi aus Altenstadt (Iller) räumt Wohnungen, Häuser und Keller. Tel. 0151 70004440.",
    h1: "Entrümpelung in Memmingen und Umgebung",
    orientation: "Orientierung: Memmingen und das Illertal zwischen Altenstadt und dem Unterallgäu",
    intro:
      "Memmingen liegt rund 25 Kilometer südlich von Altenstadt und ist über die A7 in etwa zwanzig Minuten erreichbar. Zusammen mit Kellmünz an der Iller und Babenhausen decken wir den Raum zwischen unserem Sitz und dem Unterallgäu ab – für Wohnungen, Häuser, Keller, Garagen und kleinere Gewerbeflächen.",
    body: [
      "Memmingen verbindet eine historische Altstadt mit Wohnquartieren aus allen Jahrzehnten und den Stadtteilen Amendingen, Steinheim, Dickenreishausen, Eisenburg, Buxach und Volkratshofen. In der Altstadt sind Zufahrt und Parken die entscheidenden Fragen: Wir kümmern uns um eine Halteverbotszone, wenn nötig, und planen den Ablauf so, dass Treppenhaus und Nachbarn so wenig wie möglich belastet werden. In den äußeren Stadtteilen dominieren Einfamilienhäuser mit Garage, Keller und Gartenhaus.",
      "Kellmünz an der Iller liegt auf halbem Weg zwischen Altenstadt und Memmingen und gehört damit zu den Orten, die wir am häufigsten anfahren. Babenhausen mit seinem Marktzentrum und den umliegenden Ortsteilen erreichen wir über die Staatsstraße in kurzer Zeit. In beiden Gemeinden räumen wir regelmäßig Elternhäuser vor dem Verkauf, Wohnungen nach einem Umzug ins Pflegeheim und Keller oder Dachböden vor einer Sanierung.",
      "Wie überall beginnt der Ablauf mit Ihrer Anfrage: Fotos über das Formular oder per WhatsApp, Angaben zu Etage und Zugang, bei größeren Objekten eine Besichtigung vor Ort. Danach erhalten Sie ein Angebot mit klar getrennten Positionen für Arbeitszeit, Transport und Entsorgung. Der genannte Preis gilt für den vereinbarten Umfang.",
      "Beim Einsatz sortieren wir direkt beim Verladen. Brauchbare Möbel und Hausrat geben wir nach Absprache an gemeinnützige Stellen weiter, der Rest wird über die Entsorgungsanlagen in Memmingen und im Landkreis Unterallgäu beziehungsweise Neu-Ulm fachgerecht entsorgt. Für Angehörige, die nicht in Memmingen wohnen, bieten wir Schlüsselübergabe und Fotodokumentation an. Ergänzend übernehmen wir Transporte einzelner Möbelstücke, Einlagerung und die Demontage von Einbauküchen oder Lampen.",
    ],
    towns: ["Memmingen", "Kellmünz", "Babenhausen", "Amendingen", "Steinheim", "Eisenburg"],
    audiences: ["Privathaushalte", "Erben & Angehörige", "Hausverwaltungen", "Kleingewerbe"],
    objectTypes: ["Altstadtwohnungen", "Einfamilienhäuser", "Keller & Garagen", "Kleine Gewerbeflächen"],
    highlights: [
      "Rund 20 Minuten Anfahrt über die A7",
      "Halteverbotszone und Ablaufplanung in der Altstadt",
      "Schlüsselübergabe mit Fotodokumentation für Angehörige",
    ],
    faq: [
      {
        q: "Räumen Sie in der Memminger Altstadt trotz enger Zufahrt?",
        a: "Ja. Wir prüfen vorab, wo der Transporter stehen kann, und beantragen bei Bedarf eine Halteverbotszone. Der Ablauf wird so geplant, dass Treppenhaus und Nachbarn möglichst wenig belastet werden.",
      },
      {
        q: "Wie oft sind Sie in Kellmünz im Einsatz?",
        a: "Kellmünz liegt auf unserer Strecke zwischen Altenstadt und Memmingen, wir kommen regelmäßig vorbei. Kleine Aufträge lassen sich dort gut mit anderen Terminen verbinden.",
      },
      {
        q: "Was kostet eine Haushaltsauflösung in Babenhausen?",
        a: "Das hängt von Menge, Etage und Zugang ab. Nach Fotos oder einer Besichtigung erhalten Sie ein Angebot mit festem Preis für den vereinbarten Umfang – ohne Überraschungen.",
      },
    ],
  },
  {
    slug: "biberach-oberschwaben",
    name: "Biberach und Oberschwaben",
    short: "Biberach",
    metaTitle: "Entrümpelung Biberach & Oberschwaben | Haushaltsauflösung | Rümpeltaxi",
    metaDescription:
      "Entrümpelung in Biberach an der Riß und Oberschwaben. Rümpeltaxi räumt und entsorgt zuverlässig für Privat- und Geschäftskunden.",
    h1: "Entrümpelung in Biberach und Oberschwaben",
    orientation: "Orientierung: Biberach an der Riß und umliegende Gemeinden",
    intro:
      "In Biberach an der Riß und der Region Oberschwaben unterstützen wir bei Haushalts- und Wohnungsauflösungen, Keller- und Dachbodenräumungen sowie Gewerbeauflösungen.",
    towns: ["Biberach an der Riß", "Laupheim", "Ochsenhausen", "Riedlingen", "Bad Schussenried", "Warthausen"],
    audiences: ["Privathaushalte", "Erben", "Hausverwaltungen", "Betriebe"],
    objectTypes: ["Wohnungen & Häuser", "Keller & Dachböden", "Gewerbe", "Lager"],
    highlights: [
      "Haushalts- und Nachlassauflösungen",
      "Keller-, Dachboden- und Garagenräumungen",
      "Fachgerechte Entsorgung",
    ],
  },
  {
    slug: "heidenheim-ostwuerttemberg",
    name: "Heidenheim und Ostwürttemberg",
    short: "Heidenheim",
    metaTitle: "Entrümpelung Heidenheim & Ostwürttemberg | Rümpeltaxi",
    metaDescription:
      "Entrümpelung im Raum Heidenheim und Ostwürttemberg. Rümpeltaxi übernimmt Haushaltsauflösungen, Entsorgungen und Umzüge.",
    h1: "Entrümpelung in Heidenheim und Ostwürttemberg",
    orientation: "Orientierung: rund 40 km rund um Heidenheim",
    intro:
      "Im Raum Heidenheim und in Ostwürttemberg führen wir Räumungen und Auflösungen für Privat- und Geschäftskunden durch. Auf Wunsch verbinden wir Räumung, Transport und Entsorgung zu einem Ablauf aus einer Hand.",
    towns: ["Heidenheim an der Brenz", "Giengen", "Herbrechtingen", "Aalen", "Königsbronn", "Nattheim"],
    audiences: ["Privathaushalte", "Angehörige", "Unternehmen", "Hausverwaltungen"],
    objectTypes: ["Wohnungen & Häuser", "Keller & Dachböden", "Büros", "Lager"],
    highlights: [
      "Kombinierte Räumung und Entsorgung",
      "Wohnungs- und Gewerbeauflösungen",
      "Strukturierte Terminplanung",
    ],
  },
  {
    slug: "guenzburg",
    name: "Günzburg und westliches Bayern",
    short: "Günzburg",
    metaTitle: "Entrümpelung Günzburg | Haushaltsauflösung westliches Bayern | Rümpeltaxi",
    metaDescription:
      "Entrümpelung in Günzburg und im westlichen Bayern. Rümpeltaxi räumt Wohnungen, Häuser und Gewerbeobjekte fachgerecht und diskret.",
    h1: "Entrümpelung in Günzburg und im westlichen Bayern",
    orientation: "Orientierung: Günzburg und angrenzende Orte zwischen Neu-Ulm, Günzburg und Illertissen",
    intro:
      "Zwischen Neu-Ulm, Günzburg und Illertissen sind wir häufig im Einsatz. Wir übernehmen Haushaltsauflösungen, Keller- und Dachbodenräumungen sowie Gewerbeauflösungen in der gesamten Region.",
    towns: ["Günzburg", "Leipheim", "Burgau", "Ichenhausen", "Krumbach", "Jettingen-Scheppach"],
    audiences: ["Privathaushalte", "Erben", "Betriebe", "Hausverwaltungen"],
    objectTypes: ["Wohnungen & Häuser", "Keller & Dachböden", "Gewerbe", "Nebengebäude"],
    highlights: [
      "Räumungen zwischen Neu-Ulm und Illertissen",
      "Haushalts- und Gewerbeauflösungen",
      "Individuelle Terminabstimmung",
    ],
  },
  {
    slug: "goeppingen-filstal",
    name: "Göppingen und das Filstal",
    short: "Göppingen",
    metaTitle: "Entrümpelung Göppingen & Filstal | Haushaltsauflösung | Rümpeltaxi",
    metaDescription:
      "Entrümpelung in Göppingen und im Filstal. Rümpeltaxi räumt und entsorgt zuverlässig – auch Nachlass- und Gewerbeauflösungen.",
    h1: "Entrümpelung in Göppingen und im Filstal",
    orientation: "Orientierung: Göppingen und die umliegenden Gemeinden im Filstal",
    intro:
      "Im Raum Göppingen und entlang des Filstals übernehmen wir Wohnungs- und Haushaltsauflösungen sowie Keller- und Dachbodenräumungen. Nachlassauflösungen bearbeiten wir mit der gebotenen Diskretion.",
    towns: ["Göppingen", "Eislingen", "Uhingen", "Ebersbach", "Süßen", "Geislingen", "Salach"],
    audiences: ["Privathaushalte", "Erben & Angehörige", "Hausverwaltungen"],
    objectTypes: ["Wohnungen & Häuser", "Keller & Dachböden", "Gewerbe"],
    highlights: [
      "Nachlass- und Haushaltsauflösungen",
      "Keller- und Dachbodenräumungen",
      "Fachgerechte Entsorgung",
    ],
  },
  {
    slug: "ulm-stuttgart",
    name: "Region zwischen Ulm und Stuttgart",
    short: "Ulm–Stuttgart",
    metaTitle: "Entrümpelung Region Ulm–Stuttgart | Rümpeltaxi",
    metaDescription:
      "Entrümpelung im Einsatzkorridor zwischen Ulm und Stuttgart. Rümpeltaxi räumt und transportiert zuverlässig entlang der gesamten Achse.",
    h1: "Entrümpelung zwischen Ulm und Stuttgart",
    orientation: "Orientierung: der gesamte Einsatzkorridor entlang und zwischen den Ballungsräumen",
    intro:
      "Entlang der Achse zwischen Ulm und Stuttgart sind wir regelmäßig unterwegs. Das ermöglicht flexible Termine und die Kombination von Räumung, Transport und Entsorgung – auch bei mehreren Objekten.",
    towns: ["Ulm", "Merklingen", "Geislingen", "Göppingen", "Plochingen", "Esslingen", "Stuttgart"],
    audiences: ["Privathaushalte", "Unternehmen", "Hausverwaltungen", "Makler"],
    objectTypes: ["Wohnungen & Häuser", "Gewerbe", "Keller & Dachböden", "Lager"],
    highlights: [
      "Flexible Termine entlang der Achse",
      "Kombination mehrerer Objekte möglich",
      "Transport und Räumung aus einer Hand",
    ],
  },
  {
    slug: "stuttgart",
    name: "Stuttgart und Umgebung",
    short: "Stuttgart",
    metaTitle: "Entrümpelung Stuttgart | Haushaltsauflösung | Rümpeltaxi",
    metaDescription:
      "Entrümpelung in Stuttgart und Umgebung. Rümpeltaxi räumt Wohnungen und Gewerbe – auch in Mehrfamilienhäusern und Hochlagen.",
    h1: "Entrümpelung in Stuttgart und Umgebung",
    orientation: "Orientierung: Stuttgart und angrenzende Städte nach individueller Abstimmung",
    intro:
      "In Stuttgart sind Zufahrt, Parksituation und Etagenlagen oft anspruchsvoll. Wir planen städtische Einsätze sorgfältig, organisieren bei Bedarf Halteverbotszonen und arbeiten auch in Mehrfamilienhäusern effizient.",
    towns: ["Stuttgart", "Fellbach", "Leinfelden-Echterdingen", "Esslingen", "Waiblingen", "Kornwestheim"],
    audiences: ["Privathaushalte", "Unternehmen", "Hausverwaltungen", "Kanzleien"],
    objectTypes: ["Wohnungen", "Mehrfamilienhäuser", "Büros & Praxen", "Keller"],
    highlights: [
      "Einsätze in Mehrfamilienhäusern und Hochlagen",
      "Organisation von Halteverbotszonen bei Bedarf",
      "Gewerbe- und Büroauflösungen",
    ],
  },
  {
    slug: "ludwigsburg-bietigheim",
    name: "Landkreis Ludwigsburg & Bietigheim",
    short: "Ludwigsburg",
    metaTitle: "Entrümpelung Ludwigsburg & Bietigheim-Bissingen | Rümpeltaxi",
    metaDescription:
      "Entrümpelung in Ludwigsburg, Bietigheim-Bissingen und dem nördlichen Landkreis. Rümpeltaxi räumt, transportiert und entsorgt zuverlässig.",
    h1: "Entrümpelung im Landkreis Ludwigsburg",
    orientation: "Orientierung: Ludwigsburg, Bietigheim-Bissingen und umliegende Gemeinden",
    intro:
      "In Ludwigsburg, Bietigheim-Bissingen und den umliegenden Gemeinden unterstützen wir bei Haushaltsauflösungen, Umzügen und Entsorgungen. Auf Wunsch verbinden wir Räumung, Transport und Montage.",
    towns: ["Ludwigsburg", "Bietigheim-Bissingen", "Kornwestheim", "Vaihingen an der Enz", "Besigheim", "Marbach"],
    audiences: ["Privathaushalte", "Makler", "Hausverwaltungen", "Unternehmen"],
    objectTypes: ["Wohnungen & Häuser", "Keller & Dachböden", "Gewerbe"],
    highlights: [
      "Kombinierte Räumung und Umzug",
      "Möbelmontage nach Vereinbarung",
      "Zusammenarbeit mit Maklern",
    ],
  },
  {
    slug: "heilbronn",
    name: "Stadt- und Landkreis Heilbronn",
    short: "Heilbronn",
    metaTitle: "Entrümpelung Heilbronn | Haushaltsauflösung | Rümpeltaxi",
    metaDescription:
      "Entrümpelung in Stadt und Landkreis Heilbronn. Rümpeltaxi räumt und entsorgt zuverlässig für Privat- und Geschäftskunden.",
    h1: "Entrümpelung in Stadt und Landkreis Heilbronn",
    orientation: "Orientierung: Stadt und Landkreis Heilbronn",
    intro:
      "In Stadt und Landkreis Heilbronn bearbeiten wir Wohnungs- und Gewerbeauflösungen, Entsorgungen sowie Umzüge. Für größere Projekte stimmen wir einen strukturierten Zeitplan mit Ihnen ab.",
    towns: ["Heilbronn", "Neckarsulm", "Weinsberg", "Bad Wimpfen", "Eppingen", "Brackenheim"],
    audiences: ["Privathaushalte", "Unternehmen", "Hausverwaltungen", "Erben"],
    objectTypes: ["Wohnungen & Häuser", "Gewerbe & Büros", "Keller & Dachböden", "Lager"],
    highlights: [
      "Wohnungs- und Gewerbeauflösungen",
      "Strukturierte Projektplanung",
      "Fachgerechte Entsorgung",
    ],
  },
];

export const getRegion = (slug) => regions.find((r) => r.slug === slug);

// Orte im Umkreis von ca. 30 km um Altenstadt/Ulm mit zugehöriger Cluster-Seite
export const nearbyTowns = [
  { name: "Ulm", region: "ulm-neu-ulm" },
  { name: "Neu-Ulm", region: "ulm-neu-ulm" },
  { name: "Dornstadt", region: "ulm-neu-ulm" },
  { name: "Blaustein", region: "ulm-neu-ulm" },
  { name: "Blaubeuren", region: "ulm-neu-ulm" },
  { name: "Beimerstetten", region: "ulm-neu-ulm" },
  { name: "Erbach", region: "ulm-neu-ulm" },
  { name: "Illerkirchberg", region: "ulm-neu-ulm" },
  { name: "Langenau", region: "ulm-neu-ulm" },
  { name: "Dietenheim", region: "ulm-neu-ulm" },
  { name: "Senden", region: "senden-voehringen" },
  { name: "Vöhringen", region: "senden-voehringen" },
  { name: "Nersingen", region: "senden-voehringen" },
  { name: "Elchingen", region: "senden-voehringen" },
  { name: "Altenstadt", region: "illertissen-allgaeu" },
  { name: "Illertissen", region: "illertissen-allgaeu" },
  { name: "Weißenhorn", region: "illertissen-allgaeu" },
  { name: "Pfaffenhofen an der Roth", region: "illertissen-allgaeu" },
  { name: "Bellenberg", region: "illertissen-allgaeu" },
  { name: "Buch", region: "illertissen-allgaeu" },
  { name: "Holzheim", region: "illertissen-allgaeu" },
  { name: "Memmingen", region: "memmingen" },
  { name: "Kellmünz", region: "memmingen" },
  { name: "Babenhausen", region: "memmingen" },
];
